import { useQuery } from '@tanstack/react-query';
import { useQueryCreator } from '~/hooks/useQueryCreator';
import { fulfillmentContextService } from '~/services';
import type { PartnerLaneSortConfigurationOrchestration } from '@shipium-corp/shipium-ts-types';
import { DOCK_LANE_SORT_CONFIGURATIONS_QUERY_KEY } from './dockLaneQueryKeys';

export { DOCK_LANE_SORT_CONFIGURATIONS_QUERY_KEY };

const dockLaneSortConfigurationsQuery = {
  queryKey: DOCK_LANE_SORT_CONFIGURATIONS_QUERY_KEY,
  configurationType: 'cached' as const,
  fn: async (
    laneSortConfigurationId?: string,
    originId?: string,
  ): Promise<PartnerLaneSortConfigurationOrchestration[]> => {
    const response = await fulfillmentContextService.fetchDockLaneSortConfiguration(laneSortConfigurationId, originId);
    // API returns { results: [...] } for list queries, or a single object for by-ID queries
    if (response.results) {
      return response.results;
    }
    return [response];
  },
};

interface UseDockLaneSortConfigurationsOptions {
  originId?: string;
}

export const useDockLaneSortConfigurations = (options?: UseDockLaneSortConfigurationsOptions) => {
  return useQuery({
    ...useQueryCreator(dockLaneSortConfigurationsQuery, {
      args: [undefined, options?.originId],
    }),
    enabled: options ? !!options.originId : true,
  });
};

export const useDockLaneSortConfiguration = (laneSortConfigurationId: string | undefined) => {
  return useQuery({
    ...useQueryCreator(dockLaneSortConfigurationsQuery, {
      args: [laneSortConfigurationId!],
    }),
    enabled: !!laneSortConfigurationId,
    select: (data: PartnerLaneSortConfigurationOrchestration[]) => data[0],
  });
};
